<template>
  <div class="octadesk-app-avatar">
    <img
      v-if="user.thumbUrl"
      :src="user.thumbUrl.replace('http:', 'https:')"
      :title="user.displayName || user.name"
      :alt="user.displayName || user.name"
    />

    <div v-else class="octadesk-app-disc" :style="style">
      <p
        :style="`color: rgba(${settings.fontColorRGBA});`"
        v-text="avatarName() || user.name[0]"
      ></p>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import { isClient } from '@/helpers'

  export default {
    props: ['user'],
    computed: {
      ...mapGetters(['settings', 'agent']),
      style() {
        if (isClient(this.user.type)) {
          return 'background-color: rgba(92,96,104, 1)'
        } else {
          return `background-color: rgba(${this.settings.bgColorRGB}, 1)`
        }
      },
      currentAgent() {
        if (this.agent) {
          return this.agent
        } else {
          return (
            this.inBotFlux && this.firstBotMessage && this.firstBotMessage.user
          )
        }
      }
    },
    methods: {
      displayName() {
        if (
          this.currentAgent !== undefined &&
          this.currentAgent.displayName !== undefined
        ) {
          return this.currentAgent.displayName
        }
      },
      avatarName() {
        if (this.displayName() !== undefined) {
          return this.displayName()[0]
        }
      }
    }
  }
</script>

<style></style>
